export const appConfig = () => ({
  env: process.env.NODE_ENV,
  plugin: Boolean(JSON.parse(String(process.env.REACT_APP_PLUGIN))),
  demo_quiz_id: "62bac1f8dbf17c0012f57486",
  // demo_quiz_id: String(process.env.REACT_APP_DEMO_QUIZ_ID),
  access_key: process.env.REACT_APP_ACCESS_KEY,
  api_urls: String(process.env.REACT_APP_API_URLS).split(","),
  emoji_path: String(process.env.REACT_APP_EMOJI_PATH),
  bonuses_path: String(process.env.REACT_APP_BONUSES_PATH),
  assets_url: process.env.REACT_APP_ASSETS_HOST,
  ya_client_id: process.env.REACT_APP_YA_CLIENT_ID,
  yandex_id_redirect_uri: process.env.REACT_APP_YANDEX_ID_REDIRECT_URI
});

export type AppConfig = ReturnType<typeof appConfig>;